var map = {
	"./IDeltaT.svg": "a8ee",
	"./Leste.svg": "f593",
	"./Nordeste.svg": "1fa8",
	"./Noroeste.svg": "ad75",
	"./Norte.svg": "8e62",
	"./Oeste.svg": "a6f6",
	"./Sudoeste.svg": "151b",
	"./Sul.svg": "5448",
	"./Suldeste.svg": "4bcc",
	"./deltaT.svg": "a0a7",
	"./wind_direction.svg": "1dc0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "91e0";